import ellipseBrush from '@/utils/fabric/brush/ellipseBrush.js'
import lineBrush from '@/utils/fabric/brush/lineBrush.js'
import textBrush from '@/utils/fabric/brush/textBrush.js'
import waveBrush from '@/utils/fabric/brush/waveBrush.js'
import imageBrush from '@/utils/fabric/brush/imageBrush.js'

import star3 from '@/static/images/correct/result/star3.png'
import star4 from '@/static/images/correct/result/star4.png'
import star5 from '@/static/images/correct/result/star5.png'

export const RightBrushDataUrl = `data:image/svg+xml,%3Csvg width='262' height='262' viewBox='0 0 262 262' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M94.5654 176.777L97.7555 171.741L97.8247 171.633C97.8755 171.553 97.9527 171.432 98.0559 171.272C98.2624 170.951 98.5725 170.471 98.9815 169.844C99.7997 168.591 101.014 166.753 102.585 164.428C105.728 159.777 110.3 153.184 115.997 145.439C127.404 129.931 143.264 109.884 161.154 91.5788C178.779 73.5394 198.525 57.1181 213.909 45.1816C221.591 39.2207 228.164 34.3946 232.811 31.0625C233.556 30.5282 234.252 30.0325 234.894 29.5767L239.289 41.4701C238.246 42.5309 236.869 43.9428 235.209 45.6699C231.228 49.8099 225.615 55.7641 219.066 63.0382C205.981 77.5722 189.105 97.4391 174.054 118.669C154.635 146.069 136.514 175.561 123.263 198.171C116.633 209.483 111.214 219.089 107.449 225.87C106.492 227.593 105.642 229.135 104.906 230.475L23.3218 142.462L39.033 126.204L94.5654 176.777Z' fill='%23EC4025'/%3E%3C/svg%3E%0A`
export const RightSmallBrushDataUrl = `data:image/svg+xml,%3Csvg width='82' height='78' viewBox='0 0 82 78' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M32.4648 77.4891C32.4648 77.4891 44.3264 55.2345 57.9751 35.9762C68.5085 21.1182 81.6443 8.10664 81.6443 8.10664L78.907 0.699219C78.907 0.699219 63.3255 11.2273 50.708 24.1416C37.9016 37.245 28.0647 52.7725 28.0647 52.7725L8.72007 35.1556L0.810547 43.3405L32.4648 77.4891Z' fill='%23EC4025'/%3E%3C/svg%3E%0A`
export const WrongBrushDataUrl = `data:image/svg+xml,%3Csvg width='69' height='66' viewBox='0 0 69 66' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M57.2586 65.0355L68.5364 60.6957L11.6516 0.100025L0.373788 4.43984L57.2586 65.0355Z' fill='%23EC4025'/%3E%3C/svg%3E%0A`

// 分数底部
export const ScoreBottomUrl = `data:image/svg+xml,%3Csvg width='227' height='121' viewBox='0 0 227 121' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M176.425 13.749C180.131 12.6478 182.242 8.75096 181.141 5.04511C180.04 1.33926 176.143 -0.772259 172.437 0.328907L50.008 36.7078C46.3021 37.8089 44.1906 41.7058 45.2918 45.4116C46.393 49.1175 50.2898 51.229 53.9957 50.1278L176.425 13.749Z' fill='%23EC4025'/%3E%3Cpath d='M221.136 56.8106C224.842 55.7094 226.954 51.8126 225.853 48.1067C224.751 44.4009 220.855 42.2894 217.149 43.3905L5.008 106.427C1.30215 107.528 -0.809369 111.425 0.291797 115.13C1.39296 118.836 5.28982 120.948 8.99567 119.847L221.136 56.8106Z' fill='%23EC4025'/%3E%3C/svg%3E%0A`
// 默认红色
export const DEFAULT_RED = '#EC4025'

// 笔刷列表
export const brushList = [
  {
    tip: '大对号',
    brushName: 'correctRight',
    handleName: 'addRight',
    icon: 'big-right',
    getBrush(fabric, canvas, objScale) {
      const { brushName } = this
      return imageBrush(fabric, canvas, {
        name: brushName,
        url: RightBrushDataUrl,
        scale: objScale
      })
    },
    loggerFn: 'rightIconBig' // 方法名称为埋点定义名称 src/utils/logger/correct.js
  },
  {
    tip: '小对号',
    icon: 'small-right',
    brushName: 'correctSmallRight',
    handleName: 'addSmallRight',
    getBrush(fabric, canvas, objScale) {
      const { brushName } = this
      return imageBrush(fabric, canvas, {
        name: brushName,
        url: RightSmallBrushDataUrl,
        scale: objScale
      })
    },
    loggerFn: 'rightIconSmall'
  },
  {
    tip: '斜线',
    icon: 'wrong',
    brushName: 'correctWrong',
    handleName: 'addWrong',
    getBrush(fabric, canvas, objScale) {
      const { brushName } = this
      return imageBrush(fabric, canvas, {
        name: brushName,
        url: WrongBrushDataUrl,
        scale: objScale
      })
    }

  },
  {
    tip: '输入文字',
    icon: 'text',
    brushName: 'correctText',
    handleName: 'addText',
    curOption: 64,
    loggerFn: 'inputTxt',
    // optionList: [
    //   {
    //     name: '细',
    //     key: 48
    //   },
    //   {
    //     name: '中',
    //     key: 64
    //   },
    //   {
    //     name: '粗',
    //     key: 96
    //   }
    // ],
    getBrush(fabric, canvas, objScale) {
      const { brushName, curOption } = this
      return textBrush(fabric, canvas, {
        name: brushName,
        scale: objScale,
        textConf: {
          fill: DEFAULT_RED,
          fontSize: curOption
        }
      })
    },
    setBrush(fabric, canvas, cur, objScale) {
      const { brushName, curOption } = cur
      return textBrush(fabric, canvas, {
        name: brushName,
        scale: objScale,
        textConf: {
          fill: DEFAULT_RED,
          fontSize: curOption
        }
      })
    }
  },
  {
    tip: '圆形',
    icon: 'circle',
    brushName: 'correctCircle',
    handleName: 'addCircle',
    curOption: 12,
    optionType: 'circle',
    optionList: [
      {
        name: '小',
        key: 4
      },
      {
        name: '中',
        key: 12
      },
      {
        name: '大',
        key: 18
      }
    ],
    getBrush(fabric, canvas, objScale) {
      const { brushName, curOption } = this
      const ellipse = ellipseBrush(fabric, canvas, {
        name: brushName,
        ellipse: {
          strokeWidth: parseInt(curOption * objScale),
          stroke: DEFAULT_RED
        }
      })
      return ellipse
    },
    setBrush(fabric, canvas, cur, objScale) {
      const { brushName, curOption } = this
      // 重新设置笔刷
      console.log('重新设置笔刷', curOption)
      return ellipseBrush(fabric, canvas, {
        name: brushName,
        ellipse: {
          strokeWidth: parseInt(curOption * objScale),
          stroke: DEFAULT_RED
        }
      })
    },
    loggerFn: 'circular'
  },
  {
    tip: '直线',
    icon: 'line',
    brushName: 'correctLine',
    handleName: 'addLine',
    curOption: 12,
    optionType: 'circle',
    optionList: [
      {
        name: '小',
        key: 6
      },
      {
        name: '中',
        key: 12
      },
      {
        name: '大',
        key: 16
      }
    ],
    getBrush(fabric, canvas, objScale) {
      const { brushName, curOption } = this
      return lineBrush(fabric, canvas, {
        name: brushName,
        line: {
          stroke: DEFAULT_RED,
          strokeWidth: parseInt(curOption * objScale)
        }
      })
    },
    setBrush(fabric, canvas, cur, objScale) {
      const { brushName, curOption } = cur
      return lineBrush(fabric, canvas, {
        name: brushName,
        line: {
          stroke: DEFAULT_RED,
          strokeWidth: parseInt(curOption * objScale)
        }
      })
    },
    loggerFn: 'line'
  },
  {
    tip: '波浪线',
    icon: 'wave',
    brushName: 'correctWave',
    handleName: 'addWave',
    curOption: 12,
    optionType: 'circle',
    optionList: [
      {
        name: '小',
        key: 6
      },
      {
        name: '中',
        key: 12
      },
      {
        name: '大',
        key: 16
      }
    ],
    getBrush(fabric, canvas, objScale) {
      const { brushName, curOption } = this
      return waveBrush(fabric, canvas, {
        name: brushName,
        scale: objScale,
        waveConf: {
          strokeWidth: parseInt(curOption * objScale),
          stroke: DEFAULT_RED
        }
      })
    },
    setBrush(fabric, canvas, cur, objScale) {
      const { brushName, curOption } = cur
      return waveBrush(fabric, canvas, {
        name: brushName,
        scale: objScale,
        waveConf: {
          strokeWidth: parseInt(curOption * objScale),
          stroke: DEFAULT_RED
        }
      })
    },
    loggerFn: 'curve'
  }
]

/**
 * 印章图片缓存
 */
export class ResultSealCache {
  constructor(fabric) {
    // 批改结果的印章，key 为批改结果的 key 值
    this.resultSealUrl = {
      // 三星
      7: star3,
      // 四星
      5: star4,
      // 五星
      6: star5,
      // 分数线底部
      scoreBottomUrl: ScoreBottomUrl
    }
    this.queue = new Map()
    this.resultCache = new Map()
    this.init(fabric)
  }

  init(fabric) {
    const { resultSealUrl } = this
    Object.keys(resultSealUrl).forEach(key => {
      this.getImg(fabric, key, resultSealUrl[key])
    })
  }

  /**
   * 获取图片
   * @param {*} fabric
   * @param {*} key
   * @param {*} url
   * @returns
   */
  getImg(fabric, key, url) {
    return new Promise((resolve, reject) => {
      const ques = this.queue.get(key)
      fabric.Image.fromURL(url, (img, e) => {
        if (e) {
          if (ques) {
            // 失败
            ques.forEach(que => que(null, e))
          }
          reject(e)
        } else {
          this.resultCache.set(key, img)
          console.log(key, this.resultCache)
          if (ques) {
            // 成功
            ques.forEach(que => que(img))
          }
          resolve(img)
        }
      },
      { crossOrigin: 'anonymous' })
    })
  }

  /**
   * 根据批改结果的值获取图片
   * @param {*} val 批改结果的值
   * @returns
   */
  getResultSeal(val) {
    return new Promise((resolve, reject) => {
      const result = this.resultCache.get(`${val}`)
      if (result) {
        return resolve(result)
      }
      const queueFun = (img, e) => {
        if (e) {
          return reject(e)
        }
        resolve(img)
      }
      let curQue = this.queue.get(val)
      if (curQue) {
        curQue.push(queueFun)
      } else {
        curQue = [queueFun]
      }
      this.queue.set(val, curQue)
    })
  }
}
